module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addBillingProfile_Header":"Dati di Fatturazione","NotActive":"Non attivo","formBillingProfile":{"RagioneSociale":"Ragione Sociale","CodiceFiscale":"Codice Fiscale","PartitaIva":"Partita IVA","Address":"Indirizzo","ComuneId":"Città","IsActive":"Attivo","PostalCode":"CAP"},"alertMissingBillingInfo":"Dati di fatturazione mancanti"}}')
  delete Component.options._Ctor
}
